/**
 * The line under a site name in EnviroLite: client first, then the place, then
 * how the site is reached. Same-name sites for different clients were
 * indistinguishable without it (Jim 2026-10-20).
 */
export function siteSubtitle(site: {
  client_name?: string | null;
  clientName?: string | null;
  city?: string | null;
  state?: string | null;
  via_groups?: string[] | null;
}): string {
  const client = site.client_name ?? site.clientName ?? '';
  const place = [site.city, site.state].filter(Boolean).join(', ');
  const via = site.via_groups?.length
    ? `via ${site.via_groups.join(', ')}`
    : '';
  return [client, place, via].filter(Boolean).join(' · ');
}
